import { render, staticRenderFns } from "./StudentRecordTab.vue?vue&type=template&id=72191567&scoped=true&"
import script from "./StudentRecordTab.vue?vue&type=script&lang=js&"
export * from "./StudentRecordTab.vue?vue&type=script&lang=js&"
import style0 from "./StudentRecordTab.vue?vue&type=style&index=0&id=72191567&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72191567",
  null
  
)

export default component.exports